import localConfig from './local.config'

let defaultConfig={
    baseUrl: 'https://profil.bayerischerbauernverband.de/',
    baseBbvUrl: 'https://www.bayerischerbauernverband.de',
    anmeldungBaseUrl: 'https://profil.bayerischerbauernverband.de/services/veranstaltung/',
    anmeldungShopBaseUrl: 'https://shop.bayerischerbauernverband.de/veranstaltung-',
};
//const config = defaultConfig
const config = Object.assign({}, defaultConfig, localConfig)

export default config


// WEBPACK FOOTER //
// ./src/config.js